var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tiptap',{attrs:{"extensions":_vm.extensions},on:{"onBlur":_vm.onInputChange,"onUpdate":_vm.onInputUpdate},model:{value:(_vm.object[_vm.fieldName]),callback:function ($$v) {_vm.$set(_vm.object, _vm.fieldName, $$v)},expression:"object[fieldName]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }